import usePlayerTracksData from './usePlayerTracksData.js';
import physicalMetrics from '../utils/physicalMetrics.js';

const byId = (playerId) => ({ player }) => player.playerId === playerId;
function usePhysicalMetrics({ currentTimestamp, options, playerId, playId, }) {
    const { data } = usePlayerTracksData(playId);
    if (!data)
        return null;
    const playerTrack = data.playerTracks.find(byId(playerId));
    if (!playerTrack)
        return null;
    return physicalMetrics(currentTimestamp, playerTrack, options);
}

export { usePhysicalMetrics as default };
//# sourceMappingURL=usePhysicalMetrics.js.map
